// NewAiPrompt/flag.js
//
// Self-contained build-time feature flag for the Segment Builder AI Assistant
// CONVERSATION MEMORY. Defaults OFF: when OFF, the AI Assistant popup behaves
// byte-identically to today — a single-shot prompt -> one completion, and all of
// its state lives in local component state that is destroyed when the popup is
// closed (unmounted). Nothing new is rendered.
//
// Flip per environment with REACT_APP_AI_ASSISTANT_MEMORY=true (or 1) to enable:
//   - a per-block conversation thread (see ./conversationStore.js) that SURVIVES
//     closing + reopening the popup and re-selecting the block, so the user can
//     have a real back-and-forth (e.g. "make it shorter", "now add a CTA"); and
//   - resending recent turns as context to the (stateless) AI completion
//     endpoint so follow-ups continue the thread instead of starting over.
//
// Mirrors the established local-flag convention (see
// src/components/InAppDocViewer/flag.js and
// src/components/gradientBuilder/featureFlag.js). Kept local to this module on
// purpose; at merge it can be folded into a shared constants/featureFlags.js.

const truthy = (v) => v === "true" || v === "1" || v === true;

export const AI_ASSISTANT_MEMORY_ENABLED = truthy(
  process.env.REACT_APP_AI_ASSISTANT_MEMORY
);
